/* Version: 3.5.155 */
'use client';
import { cloneElement } from 'react';
import { ACCORDION_VARIANT } from './constants.js';

function applyDefaultProps(icon, variant, theme) {
  var _icon$props$style, _icon$props$style2;
  var props = {};
  if (!icon.props.fontSize && !((_icon$props$style = icon.props.style) !== null && _icon$props$style !== undefined && _icon$props$style.fontSize)) {
    if (variant === ACCORDION_VARIANT.SECONDARY) {
      props.fontSize = '1rem';
    } else {
      props.fontSize = '1.25rem';
    }
  }
  if (!icon.props.color && !((_icon$props$style2 = icon.props.style) !== null && _icon$props$style2 !== undefined && _icon$props$style2.color)) {
    props.color = theme.colorPalette.accentColor.shade_default;
  }
  return /*#__PURE__*/cloneElement(icon, props);
}

export { applyDefaultProps };
